import React, { useEffect, useState, useCallback } from "react";

import { useHistory, useLocation, useParams } from "react-router";
import Swal from "sweetalert2";

import {
  Flex,
  Box,
  Image,
  Text,
  Button,
  Spacer,
  Icon,
  Menu,
  MenuButton,
  MenuList,
  MenuItem as ItemMenu,
  Grid,
  GridItem,
} from "@chakra-ui/react";

import { HiOutlineClipboardList } from "react-icons/hi";
import { RiHome2Line, RiTeamLine, RiErrorWarningLine } from "react-icons/ri";
import {
  MdManageAccounts,
  MdOutlineFilePresent,
  MdOutlineVolunteerActivism,
  MdOutlinePersonOutline,
  MdOutlineFamilyRestroom,
} from "react-icons/md";
import { GrCertificate } from "react-icons/gr";
import { BsFileEarmarkCheck } from "react-icons/bs";
import { IoIosGitNetwork } from "react-icons/io";

import { checkEntity } from "../../../components/router/PageData/data";
import Information from "./Information";
import MenuItem from "./MenuItem";

import ServicoAcolhimentoService from "../../../../main/services/ServicoAcolhimentoService";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { API } from "../../../../main/config";
import PerfilSAService from "../../../../main/services/PerfilSAService";
import { HamburgerIcon } from "@chakra-ui/icons";
import {
  Permission,
  anexosFunc,
  criancaFunc,
  servicoAcolhimentoFunc,
  servicos,
} from "../../../../helpers/Funcionalidades";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { PrintButton } from "../../../components/PrintButton";
import { format } from "date-fns";
import { TbBellRinging } from "react-icons/tb";
import love from "../../../../assets/images/love_no_bg.png";

const PanelBase = ({ children, loadingPainel }) => {
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();

  const [imagem, setImagem] = useState("");
  const [pagina, setPagina] = useState("");
  const [data, setData] = useState();
  const [perfil, setPerfil] = useState();
  const [pendentes, setPendentes] = useState();

  const { roleKeycloack, user, selectedProfile } = useAuthProvider();

  const perfilPronto = !!selectedProfile;

  const {
    editarServicoServ,
    cadastrarPerfilServ,
    editarPerfilServ,
    cadastrarGestaoServ,
    editarGestaoServ,
    cadastrarRegularidadeServ,
    editarRegularidadeServ,
    cadastrarPlanejamentoServ,
    editarPlanejamentoServ,
    cadastrarEquipeServ,
    editarEquipeServ,
    cadastrarRedeServ,
    cadastrarApadrinhamentoServ,
    editarApadrinhamentoServ,
    editarRedeServ,
    cadastrarVoluntariadoServ,
    editarVoluntariadoServ,
    cadastrarPenaServ,
    editarPenaServ,
    cadastrarAnexo,
    setIdPJ,
    idPJ,
    setServicoData,
    setCadastrarPerfilServ,
    setCadastrarGestaoServ,
    setCadastrarRegularidadeServ,
    setCadastrarPlanejamentoServ,
    setCadastrarEquipeServ,
    setCadastrarRedeServ,
    setCadastrarApadrinhamentoServ,
    setCadastrarVoluntariadoServ,
    setCadastrarPenaServ,
    setCadastrarAnexo,
    setEditarPerfilServ,
    setEditarGestaoServ,
    setEditarRegularidadeServ,
    setEditarPlanejamentoServ,
    setEditarApadrinhamentoServ,
    setEditarEquipeServ,
    setEditarRedeServ,
    setEditarVoluntariadoServ,
    setEditarPenaServ,
    setEditarServicoServ,
  } = useAppContext();

  function LoveIcon() {
    return (
      <Box
        boxSize="20px"
        backgroundImage={`url(${love})`}
        backgroundSize="contain"
        backgroundRepeat="no-repeat"
        backgroundPosition="center"
      />
    );
  }

  const getPendentes = useCallback(() => {
    ServicoAcolhimentoService.listarPendentes(id)
      .then((res) => {
        let tempObj = {};
        res.data.forEach((item) => {
          const tempItem = item.split(":");
          tempObj[tempItem[0]] = Number(tempItem[1]);
        });
        setPendentes(tempObj);
      })
      .catch((error) => console.log(error));
  }, [id, setPendentes]);

  const getDataSA = useCallback(() => {
    ServicoAcolhimentoService.getServicoAcolhimento(id)
      .then((res) => {
        setData(res.data);
        setIdPJ(res.data.idPessoaJuridica);
        setServicoData(res.data);
        setImagem(API + `/servico-acolhimento/logo/${id}`);
        sessionStorage.setItem("servico-passou", true);
      })
      .catch((err) => {});
  }, [id, setData, setImagem, setIdPJ, setServicoData]);

  useEffect(() => {
    if (!perfilPronto) return;

    getDataSA();

    PerfilSAService.getPerfilSA(id)
      .then((res) => {
        setPerfil(res.data);
      })
      .catch((erro) => {});

    getPendentes();
  }, [getDataSA, getPendentes, id, loadingPainel, perfilPronto]);

  useEffect(() => {
    const urlAarry = location.pathname.split("/");
    const tempPage = checkEntity(urlAarry[1], urlAarry[2]).page;
    setPagina(tempPage);

    if (!perfilPronto) return;

    if (tempPage.includes("Visualizar Perfil")) {
      PerfilSAService.getPerfilSA(id)
        .then((res) => {
          setPerfil(res.data);
        })
        .catch((erro) => {});
    }
    if (tempPage.includes("Visualizar")) {
      getPendentes();
      getDataSA();
    }
  }, [
    location.pathname,
    getDataSA,
    getPendentes,
    id,
    loadingPainel,
    perfilPronto,
  ]);

  const backAlert = (rota) => {
    if (
      cadastrarPerfilServ ||
      cadastrarGestaoServ ||
      cadastrarRegularidadeServ ||
      cadastrarPlanejamentoServ ||
      cadastrarEquipeServ ||
      cadastrarRedeServ ||
      cadastrarApadrinhamentoServ ||
      cadastrarVoluntariadoServ ||
      cadastrarPenaServ ||
      cadastrarAnexo ||
      editarPerfilServ ||
      editarGestaoServ ||
      editarRegularidadeServ ||
      editarPlanejamentoServ ||
      editarApadrinhamentoServ ||
      editarEquipeServ ||
      editarRedeServ ||
      editarVoluntariadoServ ||
      editarPenaServ ||
      editarServicoServ
    ) {
      Swal.fire({
        title: "Tem certeza que deseja cancelar?",
        text: "As informações serão perdidas.",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          if (rota) {
            history.push(rota);
          } else {
            if (
              (pagina.includes("Cadastrar") || pagina.includes("Editar")) &&
              (pagina.includes("Perfil") ||
                pagina.includes("Gestao") ||
                pagina.includes("Regularidade") ||
                pagina.includes("Planejamento") ||
                pagina.includes("Referencia") ||
                pagina.includes("Apadrinhamento"))
            ) {
              history.go(-2);
            } else {
              history.goBack();
            }
          }
          setCadastrarPerfilServ(false);
          setCadastrarGestaoServ(false);
          setCadastrarRegularidadeServ(false);
          setCadastrarPlanejamentoServ(false);
          setCadastrarEquipeServ(false);
          setCadastrarRedeServ(false);
          setCadastrarApadrinhamentoServ(false);
          setCadastrarVoluntariadoServ(false);
          setCadastrarPenaServ(false);
          setCadastrarAnexo(false);
          setEditarPerfilServ(false);
          setEditarGestaoServ(false);
          setEditarRegularidadeServ(false);
          setEditarPlanejamentoServ(false);
          setEditarApadrinhamentoServ(false);
          setEditarEquipeServ(false);
          setEditarRedeServ(false);
          setEditarVoluntariadoServ(false);
          setEditarPenaServ(false);
          setEditarServicoServ(false);
        }
      });
    } else {
      if (
        (pagina.includes("Cadastrar") || pagina.includes("Editar")) &&
        (pagina.includes("Perfil") ||
          pagina.includes("Gestao") ||
          pagina.includes("Regularidade") ||
          pagina.includes("Planejamento") ||
          pagina.includes("Referencia") ||
          pagina.includes("Apadrinhamento"))
      ) {
        history.go(-2);
      } else {
        history.goBack();
      }
    }
  };

  const handleMenuItemClick = (rota) => {
    if (
      ((pagina.includes("Cadastrar") ||
        pagina.includes("equipe") ||
        pagina.includes("voluntariado") ||
        pagina.includes("pena") ||
        pagina.includes("anexos")) &&
        (cadastrarPerfilServ ||
          cadastrarGestaoServ ||
          cadastrarRegularidadeServ ||
          cadastrarPlanejamentoServ ||
          cadastrarEquipeServ ||
          cadastrarRedeServ ||
          cadastrarApadrinhamentoServ ||
          cadastrarVoluntariadoServ ||
          cadastrarPenaServ ||
          cadastrarAnexo)) ||
      ((pagina.includes("Editar") ||
        pagina.includes("equipe") ||
        pagina.includes("voluntariado") ||
        pagina.includes("pena")) &&
        (editarPerfilServ ||
          editarGestaoServ ||
          editarRegularidadeServ ||
          editarPlanejamentoServ ||
          editarApadrinhamentoServ ||
          editarEquipeServ ||
          editarRedeServ ||
          editarVoluntariadoServ ||
          editarPenaServ ||
          editarServicoServ))
    ) {
      backAlert(rota);
    } else {
      if (rota) {
        history.push(rota);
      } else {
        history.goBack();
      }
    }
  };

  const handlePageName = () => {
    let tempName = "";
    switch (pagina) {
      case "Cadastrar Gestao":
        tempName = "Cadastrar Gestão";
        break;
      case "Editar Gestao":
        tempName = "Editar Gestão";
        break;
      case "Visualizar Gestao":
        tempName = "Visualizar Gestão";
        break;
      case "Cadastrar Rede De Referencia":
        tempName = "Cadastrar Rede De Referência";
        break;
      case "Editar Rede De Referencia":
        tempName = "Editar Rede De Referência";
        break;
      case "Visualizar Rede De Referencia":
        tempName = "Visualizar Rede De Referência";
        break;
      case "Visualizar Familia Acolhedora":
        tempName = "Visualizar Família Acolhedora";
        break;
      case "Visualizar Apadrinhamento":
        tempName = "Visualizar Programa de Apadrinhamento";
        break;
      case "Cadastrar Apadrinhamento":
        tempName = "Cadastrar Programa de Apadrinhamento";
        break;
      case "Editar Apadrinhamento":
        tempName = "Editar Programa de Apadrinhamento";
        break;
      case "Visualizar Pendencias":
        tempName = "Visualizar Pendências";
        break;
      default:
        tempName = pagina;
        break;
    }
    return tempName;
  };
  const showBottomBox =
    roleKeycloack &&
    (roleKeycloack.includes(servicos.equipeVisualizar) ||
      roleKeycloack.includes(
        servicoAcolhimentoFunc.visualizarApadrinhamentoServ,
      ) ||
      roleKeycloack.includes(servicos.pendenciasServVisualizar) ||
      roleKeycloack.includes(servicos.voluntariadoVisualizar) ||
      roleKeycloack.includes(servicos.cumprimentoVisualizar) ||
      roleKeycloack.includes(anexosFunc.anexoServicoVisualizar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(Number(idPJ))));

  return (
    <Flex
      flex={1}
      flexDir="column"
      px={{ base: "24px", "2xl": "32px" }}
      pb="20px"
      alignItems="center"
      overflow="auto"
    >
      <Flex
        pt="4px"
        flexDir="row"
        justifyContent="space-between"
        alignItems="center"
        w="100%"
      >
        <Text
          color="#252733"
          fontWeight={700}
          fontSize="24px"
          lineHeight="29.05px"
        >
          {pagina === "Visualizar" ? "Visualizar Serviço" : handlePageName()}
        </Text>
        <Button
          color="#FFF"
          backgroundColor="#169499"
          fontWeight={700}
          fontSize="15px"
          lineHeight="21.6px"
          _hover={{ bg: "#169499" }}
          onClick={(e) => {
            backAlert();
          }}
          w="84px"
        >
          Voltar
        </Button>
      </Flex>

      <Flex flexDir={{ base: "column", xl: "row" }} mt="20px" w="100%">
        {/*Menu responsivo*/}
        <Flex
          display={{ base: "block", xl: "none" }}
          textAlign="right"
          marginBottom="4%"
        >
          <Menu align="center" autoSelect={false}>
            <MenuButton
              as={Button}
              aria-label="Options"
              icon={<HamburgerIcon />}
              variant="solid"
              colorScheme="teal"
              color="#FFF"
              backgroundColor="#169499"
            >
              Menu <HamburgerIcon />
            </MenuButton>
            <MenuList>
              <ItemMenu
                height="40px"
                icon={<Icon boxSize="20px" as={HiOutlineClipboardList} />}
                onClick={() =>
                  handleMenuItemClick("/servico-acolhimento/" + id)
                }
              >
                Dados Principais
              </ItemMenu>

              <Permission
                roleKeycloack={roleKeycloack}
                func={servicos.perfilVisualizar}
                id={data?.idPessoaJuridica}
                user={user}
                visualizar={true}
              >
                <ItemMenu
                  height="40px"
                  icon={<Icon boxSize="20px" as={RiHome2Line} />}
                  onClick={() =>
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-perfil/" + id,
                    )
                  }
                >
                  <Flex>
                    <Text>Perfil</Text>
                    <Spacer />
                    {(pendentes ? pendentes.perfil === 0 : false) && (
                      <Icon
                        aria-label="Aviso de pendente"
                        color="#D80000"
                        as={RiErrorWarningLine}
                        boxSize="20px"
                      />
                    )}
                  </Flex>
                </ItemMenu>
              </Permission>
              <Permission
                roleKeycloack={roleKeycloack}
                func={servicos.gestaoVisualizar}
                id={data?.idPessoaJuridica}
                user={user}
                visualizar={true}
              >
                <ItemMenu
                  height="40px"
                  icon={<Icon boxSize="20px" as={MdManageAccounts} />}
                  onClick={() =>
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-gestao/" + id,
                    )
                  }
                >
                  <Flex>
                    <Text>Gestão</Text>
                    <Spacer />
                    {(pendentes ? pendentes.gestao === 0 : false) && (
                      <Icon
                        aria-label="Aviso de pendente"
                        color="#D80000"
                        as={RiErrorWarningLine}
                        boxSize="20px"
                      />
                    )}
                  </Flex>
                </ItemMenu>
              </Permission>
              <Permission
                roleKeycloack={roleKeycloack}
                func={servicos.regularidadeVisualizar}
                id={data?.idPessoaJuridica}
                user={user}
                visualizar={true}
              >
                <ItemMenu
                  height="40px"
                  icon={<Icon boxSize="20px" as={GrCertificate} />}
                  onClick={() =>
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-regularidade/" + id,
                    )
                  }
                >
                  <Flex>
                    <Text>Regularidade</Text>
                    <Spacer />
                    {(pendentes ? pendentes.regularidade === 0 : false) && (
                      <Icon
                        aria-label="Aviso de pendente"
                        color="#D80000"
                        as={RiErrorWarningLine}
                        boxSize="20px"
                      />
                    )}
                  </Flex>
                </ItemMenu>
              </Permission>
              <Permission
                roleKeycloack={roleKeycloack}
                func={servicos.planejamentoVisualizar}
                id={data?.idPessoaJuridica}
                user={user}
                visualizar={true}
              >
                <ItemMenu
                  height="40px"
                  icon={<Icon boxSize="20px" as={BsFileEarmarkCheck} />}
                  onClick={() => {
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-planejamento/" + id,
                    );
                  }}
                >
                  <Flex>
                    <Text>Planejamento</Text>
                    <Spacer />
                    {(pendentes ? pendentes.planejamento === 0 : false) && (
                      <Icon
                        aria-label="Aviso de pendente"
                        color="#D80000"
                        as={RiErrorWarningLine}
                        boxSize="20px"
                      />
                    )}
                  </Flex>
                </ItemMenu>
              </Permission>
              <Permission
                roleKeycloack={roleKeycloack}
                func={servicos.planejamentoVisualizar}
                id={data?.idPessoaJuridica}
                user={user}
                visualizar={true}
              >
                <ItemMenu
                  height="40px"
                  icon={<Icon boxSize="20px" as={RiTeamLine} />}
                  onClick={() =>
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-equipe/" + id,
                    )
                  }
                >
                  <Flex>
                    <Text>Equipe</Text>
                    <Spacer />
                    {(pendentes ? pendentes.equipe === 0 : false) && (
                      <Icon
                        aria-label="Aviso de pendente"
                        color="#D80000"
                        as={RiErrorWarningLine}
                        boxSize="20px"
                      />
                    )}
                  </Flex>
                </ItemMenu>
              </Permission>
              <Permission
                roleKeycloack={roleKeycloack}
                func={servicoAcolhimentoFunc.visualizarRede}
                id={data?.idPessoaJuridica}
                user={user}
                visualizar={true}
              >
                <ItemMenu
                  height="40px"
                  icon={<Icon boxSize="20px" as={IoIosGitNetwork} />}
                  onClick={() => {
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-rede-de-referencia/" +
                        id,
                    );
                  }}
                >
                  <Flex>
                    <Text>Rede de Referência</Text>
                    <Spacer />
                    {(pendentes ? pendentes.rede === 0 : false) && (
                      <Icon
                        aria-label="Aviso de pendente"
                        color="#D80000"
                        as={RiErrorWarningLine}
                        boxSize="20px"
                      />
                    )}
                  </Flex>
                </ItemMenu>
              </Permission>
              {(data
                ? data.tipoServicoAcolhimento.regime === "SAI"
                : false) && (
                <>
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={servicos.voluntariadoVisualizar}
                    id={data?.idPessoaJuridica}
                    user={user}
                    visualizar={true}
                  >
                    <ItemMenu
                      height="40px"
                      icon={
                        <Icon boxSize="20px" as={MdOutlineVolunteerActivism} />
                      }
                      onClick={() => {
                        handleMenuItemClick(
                          "/servico-acolhimento/visualizar-voluntariado/" + id,
                        );
                      }}
                    >
                      <Flex>
                        <Text>Voluntariado</Text>
                        <Spacer />
                        {(pendentes ? pendentes.voluntariado === 0 : false) && (
                          <Icon
                            aria-label="Aviso de pendente"
                            color="#D80000"
                            as={RiErrorWarningLine}
                            boxSize="20px"
                          />
                        )}
                      </Flex>
                    </ItemMenu>
                  </Permission>
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={servicos.cumprimentoVisualizar}
                    id={data?.idPessoaJuridica}
                    user={user}
                    visualizar={true}
                  >
                    <ItemMenu
                      height="40px"
                      icon={<Icon boxSize="20px" as={MdOutlinePersonOutline} />}
                      onClick={() => {
                        handleMenuItemClick(
                          "/servico-acolhimento/visualizar-pessoa-em-cumprimento-de-pena/" +
                            id,
                        );
                      }}
                    >
                      <Flex>
                        <Text mr="5px">Pessoa em Cumprimento de Pena</Text>
                        <Spacer />
                        {(pendentes ? pendentes.cumprimento === 0 : false) && (
                          <Icon
                            aria-label="Aviso de pendente"
                            color="#D80000"
                            as={RiErrorWarningLine}
                            boxSize="20px"
                          />
                        )}
                      </Flex>
                    </ItemMenu>
                  </Permission>
                </>
              )}

              {(data
                ? data.tipoServicoAcolhimento.regime === "SAF"
                : false) && (
                <Permission
                  roleKeycloack={roleKeycloack}
                  func={servicoAcolhimentoFunc.visualizarAcolhedora}
                  id={data?.idPessoaJuridica}
                  user={user}
                  visualizar={true}
                >
                  <ItemMenu
                    height="40px"
                    icon={<Icon boxSize="20px" as={MdOutlineFamilyRestroom} />}
                    onClick={() => {
                      handleMenuItemClick(
                        "/servico-acolhimento/visualizar-familia-acolhedora/" +
                          id,
                      );
                    }}
                  >
                    <Flex>
                      <Text mr="5px">Família Acolhedora</Text>
                      <Spacer />
                      {(pendentes ? pendentes.familia === 0 : false) && (
                        <Icon
                          aria-label="Aviso de pendente"
                          color="#D80000"
                          as={RiErrorWarningLine}
                          boxSize="20px"
                        />
                      )}
                    </Flex>
                  </ItemMenu>
                </Permission>
              )}

              <Permission
                roleKeycloack={roleKeycloack}
                func={servicoAcolhimentoFunc.visualizarApadrinhamentoServ}
                id={data?.idPessoaJuridica}
                user={user}
                visualizar={true}
              >
                <ItemMenu
                  height="40px"
                  icon={<Icon boxSize="20px" as={LoveIcon} />}
                  onClick={() => {
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-apadrinhamento/" + id,
                    );
                  }}
                >
                  <Flex>
                    <Text>Programa de Apadrinhamento</Text>
                    <Spacer />
                    {(pendentes ? pendentes.apadrinhamento === 0 : false) && (
                      <Icon
                        aria-label="Aviso de pendente"
                        color="#D80000"
                        as={RiErrorWarningLine}
                        boxSize="20px"
                      />
                    )}
                  </Flex>
                </ItemMenu>
              </Permission>
              <Permission
                roleKeycloack={roleKeycloack}
                func={anexosFunc.anexoServicoVisualizar}
                id={data?.idPessoaJuridica}
                user={user}
                visualizar={true}
              >
                <ItemMenu
                  height="40px"
                  icon={<Icon boxSize="20px" as={MdOutlineFilePresent} />}
                  onClick={() => {
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-anexos/" + id,
                    );
                  }}
                >
                  Anexos
                </ItemMenu>
              </Permission>
              <Permission
                roleKeycloack={roleKeycloack}
                func={servicos.pendenciasServVisualizar}
                id={data?.idPessoaJuridica}
                user={user}
                visualizar={true}
              >
                <ItemMenu
                  height="40px"
                  icon={<Icon boxSize="20px" as={TbBellRinging} />}
                  onClick={() =>
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-pendencias/" + id,
                    )
                  }
                >
                  <Flex>
                    <Text>Pendências</Text>
                    <Spacer />
                    {pendentes && pendentes?.pendencia === 0 ? (
                      <Icon
                        aria-label="Aviso de pendente"
                        color="#D80000"
                        as={RiErrorWarningLine}
                        boxSize="20px"
                      />
                    ) : (
                      <Box
                        mt={"3px"}
                        p={2}
                        aria-label="Aviso de pendente"
                        color="#D80000"
                        border="2px solid #D80000"
                        borderRadius="full"
                        boxSize="16.67px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        fontSize="10px"
                        fontWeight="bold"
                      >
                        {pendentes?.pendencia}
                      </Box>
                    )}
                  </Flex>
                </ItemMenu>
              </Permission>
            </MenuList>
          </Menu>
        </Flex>

        {/*Barra lateral*/}
        <Flex
          flexDir="column"
          bgColor="#FFF"
          px="10px"
          py="20px"
          borderRadius="16px"
          w={{ base: "100%", xl: "20%" }}
        >
          {data !== undefined ? (
            <>
              <Flex
                flexDir="column"
                alignItems="center"
                justifyContent="center"
              >
                {imagem ? (
                  <Image
                    borderRadius="full"
                    boxSize="135px"
                    src={imagem + "?" + Date.now()}
                    onError={() => setImagem("")}
                  />
                ) : (
                  <Box boxSize="135px" bgColor="#C4C4C4" borderRadius="full" />
                )}
                <Text
                  mt="10px"
                  color="#000"
                  fontWeight={700}
                  fontSize="16px"
                  lineHeight="21.6px"
                >
                  {data.nomeFantasia}
                </Text>
              </Flex>
              <Flex justifyContent={"center"} mt={4} px={{ base: 2, xl: 7 }}>
                <PrintButton idSA={id} />
              </Flex>
              <Flex flexDir="column" display={{ base: "none", xl: "flex" }}>
                <Information
                  title="Status:"
                  information={
                    data.desativado === "S"
                      ? "Desativado"
                      : data.suspenso === "S"
                        ? "Suspenso"
                        : "Ativo"
                  }
                  mt={30}
                />
                <Information
                  title="Natureza:"
                  information={
                    data.naturezaServico === "publica" ? "Pública" : "Privada"
                  }
                />
                <Information
                  title="Regime:"
                  information={
                    data.tipoServicoAcolhimento.regime === "SAI"
                      ? "Serviço de Acolhimento Institucional"
                      : "Serviço de Acolhimento Familiar"
                  }
                />
                {data.tipoServicoAcolhimento.modalidade.toUpperCase() !==
                  "NÃO SE APLICA" && (
                  <Information
                    title="Modalidade:"
                    information={data.tipoServicoAcolhimento.modalidade}
                  />
                )}
                <Information
                  title="Promotoria:"
                  information={data.promotoria.nome}
                />
                <Information
                  title="Vara da Infância:"
                  information={data.varaInfancia.nome}
                />
                <Information
                  title="Capacidade de Atendimento:"
                  information={
                    perfil ? perfil.capacidadeAcolhimento : "Não informado."
                  }
                />
                <Information
                  title="Vagas Ocupadas:"
                  information={data.vagasOcupadas}
                />
                <Information
                  title="Vagas Disponíveis:"
                  information={
                    perfil
                      ? perfil.capacidadeAcolhimento - data.vagasOcupadas
                      : "Não informado."
                  }
                />
                <Information
                  title="Data da Criação:"
                  information={
                    data.dataCriacao
                      ? format(new Date(data.dataCriacao), "dd/MM/yyyy")
                      : ""
                  }
                />
                <Information
                  title="Data da Última Atualização:"
                  information={
                    data.dataUltimaAtualizacao
                      ? format(
                          new Date(data.dataUltimaAtualizacao),
                          "dd/MM/yyyy",
                        )
                      : ""
                  }
                />
              </Flex>
            </>
          ) : (
            <LoadingSpinner loading={data === undefined} />
          )}
        </Flex>

        {/*menu completo*/}
        <Flex flexDir="column" ml={{ base: "0px", xl: "15px" }} flex={1}>
          <Grid
            mt={4}
            templateColumns="repeat(6, 1fr)"
            gap={4}
            h={"auto"}
            alignItems={"center"}
            p={2}
            borderRadius="10px"
            bgColor="#FFF"
            display={{ base: "none", xl: "grid" }}
          >
            <GridItem>
              <MenuItem
                title="Dados Principais"
                icon={<Icon boxSize="20px" as={HiOutlineClipboardList} />}
                isActive={pagina === "Visualizar"}
                onClick={() =>
                  handleMenuItemClick("/servico-acolhimento/" + id)
                }
              />
            </GridItem>

            <Permission
              roleKeycloack={roleKeycloack}
              func={servicos.perfilVisualizar}
              id={data?.idPessoaJuridica}
              user={user}
              visualizar={true}
            >
              <GridItem>
                <MenuItem
                  title="Perfil"
                  icon={<Icon boxSize="20px" as={RiHome2Line} />}
                  isActive={pagina.includes("Perfil")}
                  onClick={() =>
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-perfil/" + id,
                    )
                  }
                  pendente={pendentes ? pendentes.perfil === 0 : false}
                />
              </GridItem>
            </Permission>
            <Permission
              roleKeycloack={roleKeycloack}
              func={servicos.gestaoVisualizar}
              id={data?.idPessoaJuridica}
              user={user}
              visualizar={true}
            >
              <GridItem>
                <MenuItem
                  title="Gestão"
                  icon={<Icon boxSize="20px" as={MdManageAccounts} />}
                  isActive={pagina.includes("Gestao")}
                  onClick={() =>
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-gestao/" + id,
                    )
                  }
                  pendente={pendentes ? pendentes.gestao === 0 : false}
                />
              </GridItem>
            </Permission>
            <Permission
              roleKeycloack={roleKeycloack}
              func={servicos.regularidadeVisualizar}
              id={data?.idPessoaJuridica}
              user={user}
              visualizar={true}
            >
              <GridItem>
                <MenuItem
                  title="Regularidade"
                  icon={<Icon boxSize="20px" as={GrCertificate} />}
                  isActive={pagina.includes("Regularidade")}
                  onClick={() =>
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-regularidade/" + id,
                    )
                  }
                  pendente={pendentes ? pendentes.regularidade === 0 : false}
                />
              </GridItem>
            </Permission>
            <Permission
              roleKeycloack={roleKeycloack}
              func={servicos.planejamentoVisualizar}
              id={data?.idPessoaJuridica}
              user={user}
              visualizar={true}
            >
              <GridItem>
                <MenuItem
                  title="Planejamento"
                  icon={<Icon boxSize="20px" as={BsFileEarmarkCheck} />}
                  isActive={pagina.includes("Planejamento")}
                  onClick={() => {
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-planejamento/" + id,
                    );
                  }}
                  pendente={pendentes ? pendentes.planejamento === 0 : false}
                />
              </GridItem>
            </Permission>
            <Permission
              roleKeycloack={roleKeycloack}
              func={servicos.equipeVisualizar}
              id={data?.idPessoaJuridica}
              user={user}
              visualizar={true}
            >
              <GridItem>
                <MenuItem
                  title="Equipe"
                  icon={<Icon boxSize="20px" as={RiTeamLine} />}
                  isActive={pagina.includes("Equipe")}
                  onClick={() =>
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-equipe/" + id,
                    )
                  }
                  pendente={pendentes ? pendentes.equipe === 0 : false}
                />
              </GridItem>
            </Permission>
          </Grid>
          <Grid
            mt={4}
            templateColumns={"repeat(6, 1fr)"}
            p={2}
            gap={4}
            h={"auto"}
            alignItems={"center"}
            borderRadius="10px"
            bgColor="#FFF"
            display={{
              base: "none",
              xl: showBottomBox ? "grid" : "none",
            }}
          >
            <Permission
              roleKeycloack={roleKeycloack}
              func={servicoAcolhimentoFunc.visualizarRede}
              id={data?.idPessoaJuridica}
              user={user}
              visualizar={true}
            >
              <GridItem>
                <MenuItem
                  title="Rede de Referência"
                  icon={<Icon boxSize="20px" as={IoIosGitNetwork} />}
                  isActive={pagina.includes("Rede De Referencia")}
                  onClick={() => {
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-rede-de-referencia/" +
                        id,
                    );
                  }}
                  pendente={pendentes ? pendentes.rede === 0 : false}
                />
              </GridItem>
            </Permission>
            {(data ? data.tipoServicoAcolhimento.regime === "SAI" : false) && (
              <>
                <Permission
                  roleKeycloack={roleKeycloack}
                  func={servicos.voluntariadoVisualizar}
                  id={data?.idPessoaJuridica}
                  user={user}
                  visualizar={true}
                >
                  <GridItem>
                    <MenuItem
                      title="Voluntariado"
                      icon={
                        <Icon boxSize="20px" as={MdOutlineVolunteerActivism} />
                      }
                      isActive={pagina.includes("Voluntariado")}
                      onClick={() => {
                        handleMenuItemClick(
                          "/servico-acolhimento/visualizar-voluntariado/" + id,
                        );
                      }}
                      pendente={
                        pendentes ? pendentes.voluntariado === 0 : false
                      }
                    />
                  </GridItem>
                </Permission>
                <Permission
                  roleKeycloack={roleKeycloack}
                  func={servicos.cumprimentoVisualizar}
                  id={data?.idPessoaJuridica}
                  user={user}
                  visualizar={true}
                >
                  <GridItem>
                    <MenuItem
                      title="Pessoa em Cumprimento de Pena"
                      icon={<Icon boxSize="20px" as={MdOutlinePersonOutline} />}
                      isActive={pagina.includes(
                        "Pessoa Em Cumprimento De Pena",
                      )}
                      onClick={() => {
                        handleMenuItemClick(
                          "/servico-acolhimento/visualizar-pessoa-em-cumprimento-de-pena/" +
                            id,
                        );
                      }}
                      pendente={pendentes ? pendentes.cumprimento === 0 : false}
                    />
                  </GridItem>
                </Permission>
              </>
            )}

            {(data ? data.tipoServicoAcolhimento.regime === "SAF" : false) && (
              <>
                <Permission
                  roleKeycloack={roleKeycloack}
                  func={servicoAcolhimentoFunc.visualizarAcolhedora}
                  id={data?.idPessoaJuridica}
                  user={user}
                  visualizar={true}
                >
                  <GridItem>
                    <MenuItem
                      title="Família Acolhedora"
                      icon={
                        <Icon boxSize="20px" as={MdOutlineFamilyRestroom} />
                      }
                      isActive={pagina.includes("Familia Acolhedora")}
                      onClick={() => {
                        handleMenuItemClick(
                          "/servico-acolhimento/visualizar-familia-acolhedora/" +
                            id,
                        );
                      }}
                      pendente={pendentes ? pendentes.familia === 0 : false}
                    />
                  </GridItem>
                </Permission>
              </>
            )}

            <Permission
              roleKeycloack={roleKeycloack}
              func={servicoAcolhimentoFunc.visualizarApadrinhamentoServ}
              id={data?.idPessoaJuridica}
              user={user}
              visualizar={true}
            >
              <GridItem>
                <MenuItem
                  title="Programa de Apadrinhamento"
                  icon={<Icon boxSize="20px" as={LoveIcon} />}
                  isActive={pagina.includes("Programa De Apadrinhamento ")}
                  onClick={() => {
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-apadrinhamento/" + id,
                    );
                  }}
                  pendente={pendentes ? pendentes.apadrinhamento === 0 : false}
                />
              </GridItem>
            </Permission>
            <Permission
              roleKeycloack={roleKeycloack}
              func={anexosFunc.anexoServicoVisualizar}
              id={data?.idPessoaJuridica}
              user={user}
              visualizar={true}
            >
              <GridItem>
                <MenuItem
                  title="Anexos"
                  icon={<Icon boxSize="20px" as={MdOutlineFilePresent} />}
                  isActive={pagina.includes("Anexos")}
                  onClick={() => {
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-anexos/" + id,
                    );
                  }}
                />
              </GridItem>
            </Permission>

            <Permission
              roleKeycloack={roleKeycloack}
              func={servicos.pendenciasServVisualizar}
              id={data?.idPessoaJuridica}
              user={user}
              visualizar={true}
            >
              <GridItem>
                <MenuItem
                  title="Pendências"
                  icon={<Icon boxSize="20px" as={TbBellRinging} />}
                  isActive={pagina.includes("Pendencias")}
                  onClick={() =>
                    handleMenuItemClick(
                      "/servico-acolhimento/visualizar-pendencias/" + id,
                    )
                  }
                  pendente={
                    pendentes && pendentes?.pendencia === 0
                      ? false
                      : pendentes?.pendencia
                  }
                />
              </GridItem>
            </Permission>
          </Grid>
          {perfilPronto ? (
            children
          ) : (
            <Flex
              justifyContent="center"
              alignItems="center"
              borderRadius="10px"
              bgColor="#FFF"
              p={3}
              flex={1}
            >
              <LoadingSpinner />
            </Flex>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default PanelBase;
